<template>
  <component
    :is="compontentType"
    :type="!link ? type : false"
    :to="redirectionLink"
    class="no-outline button-full brdr-none w-100 px10 py10 bg-cl-mine-shaft :bg-cl-th-secondary ripple weight-400 h4 cl-white sans-serif fs-medium"
    :class="[
      { 'no-underline pointer align-center border-box': link, 'disabled': disabled, 'button-disabled': disabled, 'round': round },
      { 'active_office-color': activeStyle === config.rootcategories.biuro && activeColor },
      { 'activeColor': activeStyle === config.rootcategories.drukowanie && activeColor }
    ]"
    data-testid="subscribeSubmit"
    :disabled="disabled"
  >
    <slot>
      Button
    </slot>
  </component>
</template>

<script>
import config from 'config';
import focusClean from 'theme/components/theme/directives/focusClean';
import { isServer } from '@vue-storefront/core/helpers';

export default {
  data () {
    return {
      config
    }
  },
  name: 'ButtonFull',
  directives: { focusClean },
  props: {
    type: {
      type: String,
      required: false,
      default: 'button'
    },
    link: {
      type: Object,
      required: false,
      default: null
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    activeColor: {
      type: Boolean,
      required: false,
      default: false
    },
    round: {
      type: Boolean,
      required: false,
      default: true
    },
    categoryProps: {
      type: String,
      default: config.rootcategories.drukowanie
    }
  },
  computed: {
    compontentType () {
      return this.link ? 'router-link' : 'button'
    },
    redirectionLink () {
      return this.link ? this.localizedRoute(this.link) : null
    },
    activeStyle () {
      let catalog = this.$route.meta.category;
      if (catalog === undefined && !isServer) {
        if (window.location.pathname.startsWith(config.site.office_path)) {
          catalog = config.rootcategories.biuro;  
        } else {
          catalog = config.rootcategories.drukowanie;
        }
      }
      return catalog;
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/variables/colors';

.disabled {
  background-color: gray
}

.round {
  border-radius: 24px;
}

.active_office-color {
  background-color: $office-primary;
}

.button-full {
  min-width: 250px;
  display: flex;
  justify-content: center;

  &.activeColor {
    background-color: #f0047f;

    &.disabled {
      background-color: gray
    }
  }
}
</style>